/* eslint-disable */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

(pdfMake as any).vfs = (pdfFonts as any).vfs;
export interface IListagemContasReceber {
  idpagar: string;
  emissao: Date;
  vencimento: Date;
  nome: string;
  cpf: string;
  parcela: string;
  nossonumero: string;
  numero: string;
  vcompra: number;
  vpago: number;
  desconto: number;
  acrescimo: number;
  vparcela: number;
  status: boolean;
  logo: string;
  marcado: boolean;
  vpagar: number;
  venc: boolean;
  boleto: boolean;
}
async function PDFPagar(
  dados: IListagemContasReceber[],
  total: number,
  nome: string
) {
  const Tpagar = dados.reduce((acc, item) => acc + item.vpagar, 0);
  const Tacrescimo = dados.reduce((acc, item) => acc + item.acrescimo, 0);
  const Tdesconto = dados.reduce((acc, item) => acc + item.desconto, 0);
  const Tpago = dados.reduce((acc, item) => acc + item.vpago, 0);
  const logo = dados.length > 0 ? dados[0].logo : '';

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Erro canvas');

        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);

        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => reject('Erro ao carregar logo');
      img.src = url;
    });
  }
  function gerarLogoPadrao(): string {
    const canvas = document.createElement('canvas');
    canvas.width = 320;
    canvas.height = 90;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    const gradient = ctx.createLinearGradient(0, 0, 320, 0);
    gradient.addColorStop(0, '#1f2937');
    gradient.addColorStop(1, '#374151');

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    ctx.arc(45, 45, 25, 0, 2 * Math.PI);
    ctx.fillStyle = '#10b981';
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 20px Arial';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    ctx.fillText('CONTAS A PAGAR', 90, 45);

    return canvas.toDataURL('image/png');
  }

  let imageData: string;

  if (logo && logo.trim() !== '') {
    const baseUrl = (window as any).env?.REACT_APP_URL_IMGLOG || '';
    const imageUrl = baseUrl + logo;

    try {
      imageData = await getBase64ImageFromUrl(imageUrl);
    } catch {
      imageData = gerarLogoPadrao();
    }
  } else {
    imageData = gerarLogoPadrao();
  }

  const documentDefinition = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [40, 40, 40, 40],

    styles: {
      titulo: {
        fontSize: 14,
        bold: true,
        alignment: 'center'
      },
      subInfo: {
        fontSize: 10
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'white',
        fillColor: '#1f2937',
        alignment: 'center',
        margin: [0, 6, 0, 6]
      },
      tableCell: {
        fontSize: 9,
        margin: [0, 6, 0, 6]
      },
      totalValue: {
        bold: true,
        alignment: 'right',
        fillColor: '#e5e7eb',
        margin: [0, 6, 0, 6]
      },
      totalFinal: {
        bold: true,
        alignment: 'right',
        fillColor: '#d1d5db',
        margin: [0, 6, 0, 6]
      }
    },
    content: [
      {
        columns: [
          {
            image: imageData,
            width: 50,
            alignment: 'left',
            margin: [0, -15, 0, 0]
          },
          {
            text: 'RELATÓRIO DE CONTAS A PAGAR',
            style: 'titulo',
            alignment: 'center',
            width: '*'
          },
          {
            text: '',
            width: 60
          }
        ],
        margin: [0, 0, 0, 5],
        columnGap: 10
      },
      {
        table: {
          widths: ['*'],
          body: [[{ text: '', border: [false, true, false, false] }]]
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 0,
          hLineColor: () => '#1f2937'
        },
        margin: [0, 0, 0, 0]
      },
      {
        columns: [
          { text: `Parceiro: ${nome}`, style: 'subInfo' },
          {
            text: `Total do Débito: ${total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
            alignment: 'right',
            style: 'subInfo'
          }
        ],
        margin: [0, 0, 0, 0]
      },
      {
        table: {
          headerRows: 1,
          widths: Array(8).fill('*'),
          body: [
            [
              { text: 'Número', style: 'tableHeader', alignment: 'center' },
              { text: 'Emissão', style: 'tableHeader' },
              { text: 'Vencimento', style: 'tableHeader' },
              { text: 'Valor Parcela', style: 'tableHeader', alignment: 'right' },
              { text: 'Acrés.', style: 'tableHeader', alignment: 'right' },
              { text: 'Desconto', style: 'tableHeader', alignment: 'right' },
              { text: 'Valor Pago', style: 'tableHeader', alignment: 'right' },
              { text: 'Valor Pagar', style: 'tableHeader', alignment: 'right' },
            ],

            ...dados.map((item, index) => {
              const zebra = index % 2 === 0 ? '#f9fafb' : null;
              return [
                { text: item.numero, style: 'tableCell', fillColor: zebra, alignment: 'center' },
                { text: moment(item.emissao).format('DD/MM/YYYY'), alignment: 'center', style: 'tableCell', fillColor: zebra },
                { text: moment(item.vencimento).format('DD/MM/YYYY'), alignment: 'center', style: 'tableCell', fillColor: zebra },
                { text: item.vparcela.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell', fillColor: zebra },
                { text: item.acrescimo.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell', fillColor: zebra },
                { text: item.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell', fillColor: zebra },
                { text: item.vpago.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell', fillColor: zebra },
                { text: item.vpagar.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell', fillColor: zebra }
              ];
            }),
            [
              { text: '', colSpan: 4, border: [false, false, false, false] },
              {}, {}, {},
              { text: 'Total Acrés.', style: 'tableHeader' },
              { text: 'Total Desc.', style: 'tableHeader' },
              { text: 'Total Pago', style: 'tableHeader' },
              { text: 'Total Pagar', style: 'tableHeader' }
            ],
            [
              { text: '', colSpan: 4, border: [false, false, false, false] },
              {}, {}, {},
              { text: Tacrescimo.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalValue' },
              { text: Tdesconto.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalValue' },
              { text: Tpago.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalValue' },
              { text: Tpagar.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalFinal' }
            ]
          ]
        },
        layout: {
          hLineWidth: (i: number) => (i === 1 ? 1 : 0.5),
          vLineWidth: () => 0,
          hLineColor: () => '#e5e7eb'
        }
      },
      {
        text: `Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`,
        alignment: 'right',
        fontSize: 8,
        margin: [0, 20, 0, 0],
        color: '#6b7280'
      }
    ]
  };
  (pdfMake as any).createPdf(documentDefinition).open();
}
export default PDFPagar;
